export enum Branding {
  LearnAndEarn = 'LearnAndEarn',
}
